<div class="container">
  <div class="map-container w-depth">
    <agm-map [latitude]="geometry.lat" [longitude]="geometry.lng" [zoom]="mapZoom" [streetViewControl]="false"
             (zoomChange)="zoomChanged($event)"
             (centerChange)="centerChange($event)" (mapClick)="mapClick($event)">
      <agm-marker *ngIf="marker"
                  [latitude]="marker.lat"
                  [longitude]="marker.lng"
                  [animation]="'DROP'"
                  [iconUrl]="'https://wahii.com/img/icons/wahii_marker.png'">
      </agm-marker>
    </agm-map>
  </div>
  <div class="address-search-container">
    <div class="address-input">
      <input [placeholder]="'REQUEST.LOCATION.ADDRESSPLACEHOLDER' | translate"
             [title]="'REQUEST.LOCATION.ADDRESSPLACEHOLDER' | translate" [(ngModel)]="searchText"
             (input)="selectedLocation=null">
      <button type="submit" class="search-btn w-btn btn-wave" [title]="'REQUEST.LOCATION.SEARCH' | translate"
              (click)="searchLocation({address: searchText})" [disabled]="!searchText || searchText.length < 10">
        {{'REQUEST.LOCATION.SEARCH' | translate}}
      </button>
    </div>
    <div class="submit-btn-container">
      <button class="w-btn submit-btn btn-wave" (click)="submitStep()" *ngIf="selectedLocation">
        {{'REQUEST.LOCATION.SETDELIVERY' | translate}}
      </button>
    </div>
  </div>
</div>

